import { render, staticRenderFns } from "./NavigationPanel.vue?vue&type=template&id=72610020&"
import script from "./NavigationPanel.vue?vue&type=script&lang=js&"
export * from "./NavigationPanel.vue?vue&type=script&lang=js&"
import style0 from "./NavigationPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports